import SurveysCreate from "../components/views/surveys/surveysCreate.vue";
import Surveys from "../components/views/surveys/surveys.vue";
import surveyDetails from "../components/views/surveys/surveyDetails.vue";

const routes = [
  {
    path: "surveys",
    component: Surveys,
    name: "surveys",
    meta: {
      description: "List of Surveys",
      title: "Surveys",
      requiresAuth: true,
    },
  },
  {
    path: "surveys/surveysCreate/:_id/:props",
    component: SurveysCreate,
    name: "surveysCreate",
    meta: {
      title: "Add / Update Surveys",
      requiresAuth: true,
    },
  },
  {
    path: "surveys/survey-details/:_id",
    component: surveyDetails,
    name: "surveyDetails",
    meta: {
      description: "",
      title: "Survey Details",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/surveys.route.js